import Head from "next/head";
import React from "react";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import ProfileCoupons from "components/profileCoupons/ProfileCoupons/ProfileCoupons";

interface Props {}

const ProfilePage = (props: Props) => {
  return (
    <>
      <Head>
        <title>Chef Choy | la mejor comida china a domicilio en Quito</title>
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Chef Choy | la mejor comida china a domicilio en Quito"
        />
        <meta
          key="coupons"
          name="description"
          content="Aprovecha los mejores descuentos y promociones en Chef Choy, la mejor comida china a domicilio. Cupones exclusivos para nuestros clientes en Quito."
        />
        <meta
          property="og:description"
          content="Aprovecha los mejores descuentos y promociones en Chef Choy, la mejor comida china a domicilio. Cupones exclusivos para nuestros clientes en Quito."
        />
        <meta name="keywords" content="Chef Choy cupones, promos, descuentos" />
      </Head>
      <h1>Revisa nuestros descuentos y promociones en Chef Choy</h1>
      <TabsMenu>
        <ProfileCoupons />
      </TabsMenu>
    </>
  );
};

export default ProfilePage;
